import React, { useContext } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  Outlet,
} from "react-router-dom";
import StoreGate from "./components/home/StoreGate";
import { SocketProvider } from "./hooks/useSocket";
import { useStore } from "./context/StoreContext";
import { AuthContext } from "./context/AuthContext";
import Products from "./pages/products/Products";

import LaamLayout from "./pages/Laam/LaamLayout";
import LaamProducts from "./pages/Laam/LMProducts";
import ProductsDLM from "./pages/Laam/ProductsDLM";
import LaamOrders from "./pages/Laam/LMOrders";
import OrdersDLM from "./pages/Laam/OrdersDLM";
import ProductDetails from "./pages/products/ProductDetails";

import DGOrders from "./pages/Laam/DGOrders";
import DGOrderDetail from "./pages/Laam/DGOrderDetail";

import OrdersLayout from "./components/orders/OrdersLayout";
import Orders from "./pages/orders/Orders";
import OrdersBooking from "./pages/orders/OrdersBooking";
import OrdersProcessing from "./pages/orders/OrdersProcessing";
import OrdersPaid from "./pages/orders/OrdersPay";

import Dashboard from "./Dashboard";
import Login from "./pages/auth/LoginPage";
import UserRegister from "./pages/auth/SignUp";
import VerifyOtp from "./pages/auth/VerifyOtp";
import Users from "./pages/auth/Users";
import ForgotPassword from "./pages/auth/ForgotPassword";
import Logs from "./pages/system/Logs";

import OrderDetails from "./pages/orders/OrderDetails";
import Stores from "./pages/stores/Stores";
import StoresDetails from "./pages/stores/StoreDetails";
import StoreSaleReports from "./pages/stores/StoreSaleReports";
import Couriers from "./pages/couriers/Couriers";
import LoadSheet from "./pages/orders/LoadSheet";
import CourierDetails from "./pages/couriers/CourierDetails";
import Webhooks from "./pages/system/Webhooks";
import InventoryLogs from "./pages/inventory/InventoryLogs";
import VariantDetails from "./pages/products/VariantDetails";
import ConnectShopify from "./pages/stores/ConnectShopify";
import Charts from "./pages/analytics/Charts";
import ChatHome from "./pages/chat/ChatHome";

function PrivateRoute() {
  const { user } = useContext(AuthContext);
  const { selectedStore, isStoreSelected } = useStore();

  if (!user) return <Navigate to="/login" replace />;

  const storeId = isStoreSelected ? (selectedStore?.id ?? null) : null;

  return (
    <SocketProvider storeId={storeId}>
      <Outlet />
    </SocketProvider>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        {/* public */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<UserRegister />} />
        <Route path="/verify-otp" element={<VerifyOtp />} />
        <Route path="/forgot" element={<ForgotPassword />} />
        <Route path="/shopify/connect" element={<ConnectShopify />} />
        {/* private */}
        <Route element={<PrivateRoute />}>
          <Route path="/" element={<Dashboard />}>
            <Route element={<StoreGate />}>
              <Route path="products" element={<Products />} />
              <Route path="product/:id" element={<ProductDetails />} />
              <Route path="variant/:sku" element={<VariantDetails />} />
              <Route path="chart" element={<Charts />} />
              <Route path="webhooks" element={<Webhooks />} />
              <Route path="inventoryLogs" element={<InventoryLogs />} />
              <Route path="logs" element={<Logs />} />
              <Route path="salereports/:id" element={<StoreSaleReports />} />
              <Route path="couriers" element={<Couriers />} />
              <Route path="courierdetails/:id" element={<CourierDetails />} />
              <Route path="loadsheet" element={<LoadSheet />} />
              <Route path="orders" element={<OrdersLayout />}>
                <Route index element={<Orders />} />
                <Route path=":id" element={<OrderDetails />} />
                <Route path="processing" element={<OrdersProcessing />} />
                <Route path="booking" element={<OrdersBooking />} />
                <Route path="paid" element={<OrdersPaid />} />
              </Route>
              <Route path="laam" element={<LaamLayout />}>
                <Route index element={<Navigate to="products" replace />} />
                <Route path="products" element={<LaamProducts />} />
                <Route path="products/:id" element={<ProductsDLM />} />
                <Route path="orders" element={<LaamOrders />} />
                <Route path="orders/:id" element={<OrdersDLM />} />
                <Route path="dg/orders" element={<DGOrders />} />
              </Route>
              <Route path="dg/orders/:id" element={<DGOrderDetail />} />
              <Route path="chats" element={<ChatHome />} />
            </Route>
            <Route path="users" element={<Users />} />
            <Route path="stores" element={<Stores />} />
            <Route path="stores/:id" element={<StoresDetails />} />
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="not-found" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
